import { ILineInfo } from "@/domain/entities/lineInfo";
import useConvertTimeStrToMinutes from "./useConvertTimeStrToMinutes";

export default function useGetBusStopStartTime(
  lineInfo?: ILineInfo,
  busStopId?: string
): string {
  if (!lineInfo) {
    return "";
  }
  let startTime = "23:59";
  lineInfo.turns.forEach((turn) => {
    turn.busStops.forEach((busStop) => {
      if (busStopId && busStopId !== busStop.id) {
        return;
      }
      if (
        useConvertTimeStrToMinutes(startTime) >
        useConvertTimeStrToMinutes(busStop.departureTime)
      ) {
        startTime = busStop.departureTime;
      }
    });
  });
  return startTime === "23:59" ? "" : startTime;
}
